import React from "react";
import { Divider } from "@mui/material";

export default function Module_1() {
    return (
        <>
            <div className="py-4">
                <Divider>
                    <h2 className="py-4 text-uppercase text-center fs-1">
                        We embrace{" "}
                        <span className="text-decoration-underline text-underline-offset">
                            versatility
                        </span>
                    </h2>
                </Divider>
                <div className="mb-5">
                    <p>
                        While we offer a wide variety of quality products and
                        options, we are also capable of meeting the unique
                        design requirements of our customers. For example, the
                        customizing of retrofit kits has grown into a huge
                        success for DSSL. In fact, our ability to provide custom
                        designs to scale, coupled with our manufacturing
                        flexibility, set us apart from other importers and white
                        label manufacturers.
                    </p>
                    <p>
                        Today, we are moving forward and seeking growth
                        opportunities in new markets. Indeed, our versatility
                        now extends to developing a line of innovative and
                        cost-efficient specification grade products designed to
                        meet the higher quality standards of the commercial
                        sector.
                    </p>
                </div>
                {/* WHITE CONTAINER ------------------------------*/}
                {/* <div className="row g-0 border rounded overflow-hidden bg-white flex-md-row mb-4 shadow-sm h-md-250 position-relative">
                        <div className="col-md-4 p-4 d-flex flex-column position-static">
                            <h3 className="mb-2">Our Mission</h3>
                            <p className="mb-auto">
                                To earn your trust every day through agile and
                                responsive customer service, as your preferred
                                source for innovative, high performance fixtures
                                and custom lighting solutions.
                            </p>
                        </div>
                        <div className="col-md-4 p-4 d-flex flex-column position-static">
                            <h3 className="mb-2">Our Mission</h3>
                            <p className="mb-auto">
                                To earn your trust every day through agile and
                                responsive customer service, as your preferred
                                source for innovative, high performance fixtures
                                and custom lighting solutions.
                            </p>
                        </div>
                        <div className="col-md-4 p-4 d-flex flex-column position-static">
                            <h3 className="mb-2">Our Mission</h3>
                            <p className="mb-auto">
                                To earn your trust every day through agile and
                                responsive customer service, as your preferred
                                source for innovative, high performance fixtures
                                and custom lighting solutions.
                            </p>
                        </div>
                    </div> */}
                <div className="row g-1 my-2">
                    <div className="col-md-4">
                        <div className="row g-0 bg-white border rounded overflow-hidden flex-md-row shadow-sm h-md-250 position-relative">
                            <div className="col p-4 d-flex flex-column position-static feature">
                                <p className="m-0">
                                    East Ridge Mall – 850 DXR track kits
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="row g-0 bg-white border rounded overflow-hidden flex-md-row shadow-sm h-md-250 position-relative">
                            <div className="col p-4 d-flex flex-column position-static feature">
                                <p className="m-0">
                                    Custom adjustments to track heads
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="row g-0 bg-white border rounded overflow-hidden flex-md-row shadow-sm h-md-250 position-relative">
                            <div className="col p-4 d-flex flex-column position-static feature">
                                <p className="m-0">
                                    3 ¼” x 3 ¼” plates delivering 4300 lumens
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
